import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PATHS from '../../../../../routes/routes.const';
import { useAuthContext } from '../../../../login/AuthContext';

const RETRY_COUNTDOWN_SECONDS = 10;
const SECOND_IN_MILLISECONDS = 1000;

const useServerErrorPage = () => {
  const { forceLogout } = useAuthContext();
  const history = useHistory<{ lastPathname?: string }>();

  const [counter, setCounter] = useState(RETRY_COUNTDOWN_SECONDS);

  const retry = () => {
    const { lastPathname } = history.location.state ?? {};
    const shouldRetryLastPath = lastPathname && lastPathname !== PATHS.public.serverError.path;

    window.location.href = shouldRetryLastPath ? lastPathname : PATHS.main.home.path;
  };

  useEffect(() => {
    if (counter <= 0) {
      retry();

      return;
    }

    const intervalId = setInterval(() => {
      setCounter((previousCounter) => previousCounter - 1);
    }, SECOND_IN_MILLISECONDS);

    return () => {
      clearInterval(intervalId);
    };
  }, [counter]);

  return { counter, isRetryingAutomatically: counter > 0, retry, logout: forceLogout };
};

export default useServerErrorPage;
